const state = {
    id: undefined,
    object: undefined,
    currentPageTitle: undefined,

    content: {}
};
const getters = {};
const actions = {
    addContent(context, {key, value}) {
        let content = context.state.content;
        content[key] = value;
        context.commit('setContent', content);
    },
    addContentByObj(context, object) {
        let content = context.state.content;
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                content[key] = object[key];
            }
        }
        context.commit('setContent', content);
    }
};
const mutations = {
    setId(state, val) {
        state.id = val;
    },
    setObject(state, val) {
        state.object = val
    },
    setContent(state, val) {
        state.content = val;
    },
    setCurrentPageTitle(state, val) {
        state.currentPageTitle = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
